import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IWordExamVm } from '../word-exam-vm.model';
import { InternalExamResult, IOskStudentWordExamResultIm } from '../internal-exam-classification.model';
@Injectable({ providedIn: 'root' })
export class OskStudentWordExamService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OskStudentWordExam`;
  }
  get(wordExamGuid: string, withUserSensitiveData: boolean): Observable<IWordExamVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (wordExamGuid !== undefined && wordExamGuid !== null) {
      params = params.set('wordExamGuid', wordExamGuid.toString());
    }
    if (withUserSensitiveData !== undefined && withUserSensitiveData !== null) {
      params = params.set('withUserSensitiveData', withUserSensitiveData.toString());
    }
    return this.http.get<IWordExamVm>(this.baseUrl, { headers, params });
  }
  setResult(wordExamGuid: string, result: InternalExamResult): Observable<IWordExamVm> {
    const body: IOskStudentWordExamResultIm = { wordExamGuid, result };
    return this.http.put<IWordExamVm>(`${this.baseUrl}/result`, body, {
      headers: this.createHeaders(),
    });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
